import { useState } from "react";
import HeaderFormLogistic from "./headerFormLogistic/headerFormLogistic";
import GridLogistic from "./gridLogistic/gridLogistic";
import { HeaderText } from "@/main/components/shared/styles";
import { getTranslateByKey } from "@/main/services/utils";
import { IStatesDataDeliveryLogistic } from "./types";
import * as S from "./styles";

interface IDeliveryLogisticProps extends IStatesDataDeliveryLogistic {}
function DeliveryLogistic({ dataDeliverLogistic, setDataDeliverLogistic }: IDeliveryLogisticProps) {
	const [idsErrorDataDeliverLogistic, setIdsErrorDataDeliverLogistic] = useState<string[]>([]);

	return (
		<S.Container>
			<S.AreaHeader>
				<HeaderText>{getTranslateByKey("information.deliveryTypeWithoutLogisticCompany")}</HeaderText>
				<S.SubHeader>{getTranslateByKey("information.warningDeliveryPrice")}</S.SubHeader>
			</S.AreaHeader>
			<HeaderFormLogistic
				dataDeliverLogistic={dataDeliverLogistic}
				setDataDeliverLogistic={setDataDeliverLogistic}
				setIdsErrorDataDeliverLogistic={setIdsErrorDataDeliverLogistic}
			/>
			<GridLogistic
				dataDeliverLogistic={dataDeliverLogistic}
				idsErrorDataDeliverLogistic={idsErrorDataDeliverLogistic}
				setDataDeliverLogistic={setDataDeliverLogistic}
			/>
		</S.Container>
	);
}

export default DeliveryLogistic;
